import React from "react";
import {labelService} from "../../jwt/_services/configuration/labelService";

export const labelProvider = {
    getOptions
}

async function getOptions(customFilter) {
    try {
        const listItems = await labelService.getOptions( customFilter );

        return listItems.map( ({id, code, name}) => ({
                id,
                value: `${code}${name ? ` - ${name}` : ''}`,
                label: <label>{ `${code}${name ? ` - ${name}` : ''}` }</label>
            })
        );
    } catch (error) {
        console.log(error.message)
    }
}